// This file is auto-generated by @skynet/data-helpers/scripts/generate-rtk-exports.mjs
// Do not edit manually.

import { hookExports } from './smm-api';

export const useListSocialPosts: typeof hookExports.useListSocialPosts =
  hookExports.useListSocialPosts;
export const useLazyListSocialPosts: typeof hookExports.useLazyListSocialPosts =
  hookExports.useLazyListSocialPosts;
export const useGetSocialPost: typeof hookExports.useGetSocialPost = hookExports.useGetSocialPost;
export const useLazyGetSocialPost: typeof hookExports.useLazyGetSocialPost =
  hookExports.useLazyGetSocialPost;
export const useCreateSocialPost: typeof hookExports.useCreateSocialPost =
  hookExports.useCreateSocialPost;
export const useUpdateSocialPost: typeof hookExports.useUpdateSocialPost =
  hookExports.useUpdateSocialPost;
export const useDeleteSocialPost: typeof hookExports.useDeleteSocialPost =
  hookExports.useDeleteSocialPost;
export const useRegenerateSocialPost: typeof hookExports.useRegenerateSocialPost =
  hookExports.useRegenerateSocialPost;
export const useApproveSocialPost: typeof hookExports.useApproveSocialPost =
  hookExports.useApproveSocialPost;
export const useUnscheduleSocialPost: typeof hookExports.useUnscheduleSocialPost =
  hookExports.useUnscheduleSocialPost;
export const useRedraftSocialPost: typeof hookExports.useRedraftSocialPost =
  hookExports.useRedraftSocialPost;
export const useCancelSocialPost: typeof hookExports.useCancelSocialPost =
  hookExports.useCancelSocialPost;
export const useUnpublishSocialPost: typeof hookExports.useUnpublishSocialPost =
  hookExports.useUnpublishSocialPost;
export const usePresignSocialPostMedia: typeof hookExports.usePresignSocialPostMedia =
  hookExports.usePresignSocialPostMedia;
export const useRegisterSocialPostMedia: typeof hookExports.useRegisterSocialPostMedia =
  hookExports.useRegisterSocialPostMedia;
export const useRemoveSocialPostMedia: typeof hookExports.useRemoveSocialPostMedia =
  hookExports.useRemoveSocialPostMedia;
export const useListSocialAccounts: typeof hookExports.useListSocialAccounts =
  hookExports.useListSocialAccounts;
export const useLazyListSocialAccounts: typeof hookExports.useLazyListSocialAccounts =
  hookExports.useLazyListSocialAccounts;
